<section class="banner-wrapper">
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <div class="mwb-hub-banner-content">
        <div class="post">
          <div class="skeleton h-line"></div>
          <div class="skeleton p-line"></div>
          <div class="skeleton p-line"></div>
          <div class="skeleton p-line"></div>
          <div class="skeleton p-line"></div>
          <div class="skeleton b-line"></div>
        </div>
      </div>
      </div>
      <div class="col-md-6">
        <div class="post">
          <div class="skeleton box-line"></div>
        </div>
      </div>
    </div>
  </div>
</section>


<section class="hub-tab-wrapper">
  <div class="container">
    <div class="tab-menu">
      <ul class="post">
        <li class="skeleton line"></li>
        <li class="skeleton line"></li>
        <li class="skeleton line"></li>
        <li class="skeleton line"></li>
        <li class="skeleton line"></li>
        <li class="skeleton line"></li>
      </ul>
    </div>
    <div class="mt-5">
      <div class="tab-header">
        <div class="post">
          <div class="skeleton h-line"></div>
        </div>
        <div class="post text-right">
          <div class="skeleton b-line"></div>
        </div>
      </div>
      <div class="mb-4 mwb-hub-expansion-wrapper">
        <div class="mwb-hub-expansion-header">
          <div class="post">
            <div class="skeleton h-line"></div>
          </div>
        </div>
        <div class="mwb-hub-expansion-content">
          <div class="post">
            <div class="skeleton p-line"></div>
            <div class="skeleton p-line"></div>
            <div class="skeleton p-line"></div>
          </div>
          <div class="check-box-s">
            <ul class="post">
              <li class="skeleton p-line"></li>
              <li class="skeleton p-line"></li>
              <li class="skeleton p-line"></li>
              <li class="skeleton p-line"></li>
              <li class="skeleton p-line"></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="mb-4 mwb-hub-expansion-wrapper">
        <div class="mwb-hub-expansion-header">
          <div class="post">
            <div class="skeleton h-line"></div>
          </div>
        </div>
        <div class="mwb-hub-expansion-content">
          <div class="post">
            <div class="skeleton p-line"></div>
            <div class="skeleton p-line"></div>
            <div class="skeleton p-line"></div>
          </div>
          <div class="check-box-s">
            <ul class="post">
              <li class="skeleton p-line"></li>
              <li class="skeleton p-line"></li>
              <li class="skeleton p-line"></li>
              <li class="skeleton p-line"></li>
              <li class="skeleton p-line"></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="mb-4 mwb-hub-expansion-wrapper">
        <div class="mwb-hub-expansion-header">
          <div class="post">
            <div class="skeleton h-line"></div>
          </div>
        </div>
        <div class="mwb-hub-expansion-content">
          <div class="post">
            <div class="skeleton p-line"></div>
            <div class="skeleton p-line"></div>
            <div class="skeleton p-line"></div>
          </div>
          <div class="check-box-s">
            <ul class="post">
              <li class="skeleton p-line"></li>
              <li class="skeleton p-line"></li>
              <li class="skeleton p-line"></li>
              <li class="skeleton p-line"></li>
              <li class="skeleton p-line"></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="mb-4 mwb-hub-expansion-wrapper">
        <div class="mwb-hub-expansion-header">
          <div class="post">
            <div class="skeleton h-line"></div>
          </div>
        </div>
        <div class="mwb-hub-expansion-content">
          <div class="post">
            <div class="skeleton p-line"></div>
            <div class="skeleton p-line"></div>
            <div class="skeleton p-line"></div>
          </div>
          <div class="check-box-s">
            <ul class="post">
              <li class="skeleton p-line"></li>
              <li class="skeleton p-line"></li>
              <li class="skeleton p-line"></li>
              <li class="skeleton p-line"></li>
              <li class="skeleton p-line"></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="mb-4 mwb-hub-expansion-wrapper">
        <div class="mwb-hub-expansion-header">
          <div class="post">
            <div class="skeleton h-line"></div>
          </div>
        </div>
        <div class="mwb-hub-expansion-content">
          <div class="post">
            <div class="skeleton p-line"></div>
            <div class="skeleton p-line"></div>
            <div class="skeleton p-line"></div>
          </div>
          <div class="check-box-s">
            <ul class="post">
              <li class="skeleton p-line"></li>
              <li class="skeleton p-line"></li>
              <li class="skeleton p-line"></li>
              <li class="skeleton p-line"></li>
              <li class="skeleton p-line"></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>